module.exports = __webpack_public_path__ + "img/store-m.85daea5b.png";